import script from "./ProviderProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderProfile.vue?vue&type=script&setup=true&lang=js"

import "./ProviderProfile.vue?vue&type=style&index=0&id=41c3ac8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c3ac8e"]])

export default __exports__